import { CHART_STACKING_TYPE, CHART_TYPE, IDefaultSeries, YAXIS_POSITION } from 'xangle-charts'

import {
  EvmAnalyticsGeneralChartDataInfo,
  EvmAnalyticsGeneralChartInfo,
  EvmAnalyticsGeneralChartListInfo
} from '~/api/repository'
import { DATE_FORMATS, secondsToDate } from '~/utils/dateFormat'

export class ChartDataModel {
  public day: string
  public value: string

  constructor (data: EvmAnalyticsGeneralChartDataInfo) {
    this.day = secondsToDate(Number(data.TS), DATE_FORMATS.dateOnlyDash, 'utc')
    this.value = data.VAL
  }
}

export class ChartDataListModel {
  private _dataName: string
  private _dataList: Array<EvmAnalyticsGeneralChartDataInfo>

  constructor (data: EvmAnalyticsGeneralChartInfo) {
    this._dataName = data.DATANM
    this._dataList = data.DATA
  }

  get dataName (): string {
    return this._dataName
  }

  get dataList (): Array<ChartDataModel> {
    return this._dataList.map(data => new ChartDataModel(data))
  }

  getChartModel (index: number): IDefaultSeries {
    return {
      name: this.dataName,
      yAxis: index / 2 ? YAXIS_POSITION.RIGHT : YAXIS_POSITION.LEFT,
      unit: '',
      decimalPoint: 8,
      type: this.dataList.length === 1 ? CHART_TYPE.SCATTER : CHART_TYPE.LINE,
      stacking: CHART_STACKING_TYPE.NONE,
      data: this.dataList.map(data => {
        return {
          day: data.day,
          value: data.value
        }
      })
    }
  }
}

export class LineChartModel {
  private _chartName: string
  private _chartDescription: string
  private _chartDataList: Array<EvmAnalyticsGeneralChartInfo>

  constructor (data: EvmAnalyticsGeneralChartListInfo) {
    this._chartName = data.CHRTNM
    this._chartDescription = data.CHRTDESC
    this._chartDataList = data.CHRTLIST
  }

  get chartName (): string {
    return this._chartName
  }

  get chartDescription (): string {
    return this._chartDescription
  }

  get chartDataList () {
    return this._chartDataList.map((data, index) => new ChartDataListModel(data).getChartModel(index))
  }

  getFileName () {
    return this.chartName.replace(': ', '_').trim()
  }
}